const e = {
  mobile: 600,
  tablet: 900,
  desktop: 1200,
  desktopLarge: 1600
};
export {
  e as BREAKPOINTS
};
